import { LoadingEnum } from "@perxis-auto/shared";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { formsActions } from "../forms/reducer.js";
import { selectCurrentEntity as selectCurrentEntity$1 } from "../forms/selectors.js";
import { stagesActions } from "./reducer.js";
import { selectCurrentEntity } from "./selectors.js";
import { StageEntityId } from "./types.js";
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  actionCreator: stagesActions.getStages.fulfilled,
  effect: (action, listenerApi) => {
    var _a;
    const state = listenerApi.getState();
    const current = selectCurrentEntity(state);
    const stages = action.payload;
    if (current) {
      return;
    }
    if (!stages.length || !((_a = stages[0]) == null ? void 0 : _a.id)) {
      listenerApi.dispatch(stagesActions.setCurrent(StageEntityId.ERROR));
      return;
    }
    listenerApi.dispatch(stagesActions.setCurrent(stages[0].id));
  }
});
listenerMiddleware.startListening({
  actionCreator: stagesActions.getStages.rejected,
  effect: (action, listenerApi) => {
    listenerApi.dispatch(stagesActions.setService(null));
    listenerApi.dispatch(stagesActions.setCurrent(StageEntityId.ERROR));
  }
});
listenerMiddleware.startListening({
  actionCreator: stagesActions.setCurrent,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const stage = selectCurrentEntity(state);
    const form = selectCurrentEntity$1(state);
    if (!stage) {
      return;
    }
    listenerApi.dispatch(stagesActions.setLoading(LoadingEnum.Idle));
    listenerApi.dispatch(stagesActions.setError());
    listenerApi.dispatch(formsActions.setLoading(LoadingEnum.Idle));
    if (form) {
      return;
    }
    listenerApi.dispatch(
      formsActions.addForm({
        id: stage.form.id,
        fields: {}
      })
    );
  }
});
listenerMiddleware.startListening({
  actionCreator: stagesActions.reset,
  effect: (action, listenerApi) => {
    listenerApi.dispatch(formsActions.reset());
  }
});
const { middleware: stagesMiddleware } = listenerMiddleware;
export {
  stagesMiddleware
};
